class MModal extends HTMLElement {
    constructor() {
        super()
        this.trigger = this.querySelector('.m-modal__trigger')
        this.dialog = this.querySelector('.m-modal__dialog')
        if (this.trigger) {
            this.bindTriggerClick.bind(this)()
        }
    }
    bindTriggerClick() {
        this.querySelector('.m-modal__trigger').addEventListener('click', () => {
            this.open.bind(this)()
        })
    }
    open() {
        // append to body
        this.dialog.classList.add('m-modal--open')
        document.body.appendChild(this.dialog)
        this.dialog.querySelector('.m-modal__dialog-close').addEventListener('click', () => {
            this.close()
        })
    }
    close() {
        this.dialog.classList.remove('m-modal--open')
        this.appendChild(this.dialog)
    }
}

customElements.define('m-modal', MModal)